export default function createArticleProps({
  sourceTitle: publicationName,
  itemTitle: title,
  ...doc // includes "doi, eid, authors, publicationDate, pii, pdfPath"
}) {
  return {
    publicationName,
    title,
    ...doc,
  };
}
